import React from 'react';

import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Button, Col, Divider, Modal, Row } from 'antd';
import { revertSuggestions } from '../../data/store/portfolio/portfolioActions';

const ModalRevertCandidat = ({ modalRevertCandidat, setModalRevertCandidat, name }) => {
  console.log('🚀 ~ ModalRevertCandidat ~ name:', name);
  const { t } = useTranslation('');
  const dispatch = useDispatch();

  const handleCloseDelModal = () => {
    setModalRevertCandidat(null);
  };

  const handleRevert = () => {
    dispatch(revertSuggestions(modalRevertCandidat));
    setModalRevertCandidat(null);
  };

  return (
    <Modal
        width={700}
        className="modal-content-paper custom-modal"
        open={modalRevertCandidat}
        onCancel={handleCloseDelModal}
        footer={null}
        destroyOnClose={true}
        zIndex={1600}>
        <div>
          <h1 className='modal-header-title' >{t('MODAL_CONFIRM_REVERT')}</h1>
          <Divider className='filter-divider' style={{marginTop: '32px'}}/>
          <Row justify="start" className="modal-text-wrapper">
            <Col>
              <p className="modal-advisor-text modal-question-text">{t('REVERT_TEXT')}</p>
              <p className="modal-advisor-name modal-item-name">{name}</p>
            </Col>
          </Row>
        </div>
        <Row justify='end' className="modal-footer-btn-wrapper">
          <Button
            className="modal-action-btn cancel-btn"
            onClick={handleCloseDelModal}
          >
            {t('CANCEL')}
          </Button>
          <Button className="modal-action-btn delete-btn" onClick={handleRevert}>
            {t('REVERT')}
          </Button>
        </Row>
      </Modal>
  );
};

export default ModalRevertCandidat;

ModalRevertCandidat.propTypes = {
  name: PropTypes.string,
  modalRevertCandidat: PropTypes.number,
  setModalRevertCandidat: PropTypes.func,
};
